var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{ref:"form",staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit', { isValid: _setup.isValid, models: _setup.models })}}},[_vm._t("default",null,{"models":_setup.models,"isValid":_setup.isValid,"clear":_setup.clear})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }